import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { AbstractBankTransferAddComponent, mapStateToProps } from './abstract'
import { Button, Input, TextArea, Checkbox } from '~/components/form'
import DatePicker from 'react-datepicker'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as route from '~/helper/constant/route'
import { withTranslation } from 'react-i18next'
import { Loading } from '~/components/loader'
import * as SVG from '~/assets/svg'
import Select from 'react-select'
import { convertADtoBS } from '~/helper/function'

class BankTransferAddComponent extends AbstractBankTransferAddComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this.selectList = this.selectList.bind(this)
        this._date = this._date.bind(this)
    }

    _date(data) {
        this._handleChange('date', data)
    }
    selectList(selecttype, data) {
        const { allAccounts } = this.state

        // Filter out the selected item from the options
        const filteredAccounts = allAccounts.filter((item) => item.id !== data.value)

        // Update the state variables
        this.setState({
            [`default${selecttype}`]: data,
            [`selected${selecttype}`]: data.value,
            [`${selecttype === 'FromAccount' ? 'toAccount' : 'fromAccount'}`]: filteredAccounts.map((item) => ({
                label: item.holder_name,
                value: item.id,
            })),
        })
    }
    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text="Saving" />
                <Sidebar id="banking" isAccount={true} />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; </a>
                            </li>
                            <li>
                                <a href={route.admin.accounting.banking.menu}>
                                    {t('banking:banking')} &nbsp; &gt; &nbsp;
                                </a>
                            </li>
                            <li>
                                <a href={route.admin.accounting.banking.transfer.view}>
                                    {t('banking:bankbalancetransfer')} &nbsp; &gt; &nbsp;{' '}
                                </a>
                            </li>
                            <li>{t('common:addBtn')}</li>
                        </ul>

                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('banking:createtransfer')} :</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('banking:fromaccount')} *</label>
                                    <Select
                                        name="from_account"
                                        options={this.state.fromAccount}
                                        placeholder={t('banking:selectfromaccount')}
                                        searchable={true}
                                        value={this.state.defaultFromAccount}
                                        onChange={(data) => this.selectList('FromAccount', data)}
                                    />
                                    {this.state.errors.selectedFromAccount && (
                                        <label className="error text-danger">{this.state.errors.selectedFromAccount}</label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('banking:toaccount')} *</label>
                                    <Select
                                        name="to_account"
                                        options={this.state.toAccount}
                                        placeholder={t('banking:selecttoaccount')}
                                        searchable={true}
                                        value={this.state.defaultToAccount}
                                        onChange={(data) => this.selectList('ToAccount', data)}
                                    />
                                    {this.state.errors.selectedToAccount && (
                                        <label className="error text-danger">{this.state.errors.selectedToAccount}</label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('fee:fee_amount')} *</label>
                                    <Input
                                        name="amount"
                                        onChange={this._handleChange}
                                        placeholder={t('fee:fee_amount')}
                                        type="text"
                                        value=""
                                    />
                                    {this.state.errors.amount && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.amount}
                                        </label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('header:date')} *</label>
                                    <DatePicker
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        placeholderText={t('fromdate')}
                                        selected={this.state.date}
                                        onChange={this._date}
                                    />
                                    {this.props.school != null &&
                                        this.props.school.school != null &&
                                        this.props.school.school.date_format == 'BS' && (
                                            <label className="date-bs">
                                                {this.state.date != ''
                                                    ? convertADtoBS(this.state.date) != null
                                                        ? convertADtoBS(this.state.date) + ' BS'
                                                        : 'Invalid Date Range'
                                                    : ''}
                                            </label>
                                        )}

                                    {this.state.errors.date && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.date}
                                        </label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('banking:reference')} *</label>
                                    <Input
                                        name="reference"
                                        type="text"
                                        onChange={this._handleChange}
                                        placeholder={t('banking:reference')}
                                        value=""
                                    />

                                    {this.state.errors.reference && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.reference}
                                        </label>
                                    )}
                                </div>

                                <div className="col-sm-12 float-left form-group">
                                    <label className="form-title">{t('common:description')} *</label>
                                    <TextArea
                                        name="description"
                                        onChange={this._handleChange}
                                        placeholder={t('common:description')}
                                    />

                                    {this.state.errors.description && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.description}
                                        </label>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="form-button text-left">
                        <Button onClick={this.onSave} type="submit" text={t('common:savebtn')} main={true} />
                    </div>
                </div>
            </div>
        )
    }
}

const BankTransferAdd = withTranslation()(connect(mapStateToProps)(BankTransferAddComponent))
export { BankTransferAdd }
